export default __webpack_public_path__ + "static/media/claimInsurance.3893f640.png";